import React from 'react';
import { Container } from './styles';
import { Icon } from '@gerdau/hefesto/Icon';

const DateWindowNotOpen: React.FC = () => {
  return (
    <Container>
      <Icon option="Award" variant="primary" size="full" />
      <div className="text">
        <p className="subtitle">
          Estamos fora da janela para resgate de pontos.
        </p>
        <p className="subtitle">
          Seus pontos estarão disponiveis para resgate durante a segunda
          quinzena de cada mês.
        </p>
      </div>
    </Container>
  );
};

export default DateWindowNotOpen;
